import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Contact from '@/components/Contact'
import Success from '@/components/Success'
import BuySuccess from '@/components/BuySuccess'
import BuySuccess2 from '@/components/BuySuccess2'
import BuySuccess3 from '@/components/BuySuccess3'
import BuySuccess4 from '@/components/BuySuccess4'
import BuySuccess5 from '@/components/BuySuccess5'
import BuySuccess6 from '@/components/BuySuccess6'
import BuySuccess7 from '@/components/BuySuccess7'
import BuySuccess8 from '@/components/BuySuccess8'
import BuySuccess9 from '@/components/BuySuccess9'
import BuySuccess10 from '@/components/BuySuccess10'
import BuySuccess11 from '@/components/BuySuccess11'
import BuySuccess12 from '@/components/BuySuccess12'
import Test from '@/components/Test'
import ContactTest from '@/components/ContactTest'
import BuySuccessTest from '@/components/BuySuccessTest'
import Cancel from '@/components/Cancel'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/contact/test',
      name: 'ContactTest',
      component: ContactTest
    },
    {
      path: '/contact/success',
      name: 'Success',
      component: Success
    },
    {
      path: '/success',
      name: 'BuySuccess',
      component: BuySuccess
    },
    {
      path: '/success2',
      name: 'BuySuccess2',
      component: BuySuccess2
    },
    {
      path: '/test',
      name: 'Test',
      component: Test
    },
    {
      path: '/success3',
      name: 'BuySuccess3',
      component: BuySuccess3
    },
    {
      path: '/success4',
      name: 'BuySuccess4',
      component: BuySuccess4
    },
    {
      path: '/success5',
      name: 'BuySuccess5',
      component: BuySuccess5
    },
    {
      path: '/success6',
      name: 'BuySuccess6',
      component: BuySuccess6
    },
    {
      path: '/success7',
      name: 'BuySuccess7',
      component: BuySuccess7
    },
    {
      path: '/success8',
      name: 'BuySuccess8',
      component: BuySuccess8
    },
    {
      path: '/success9',
      name: 'BuySuccess9',
      component: BuySuccess9
    },
    {
      path: '/success10',
      name: 'BuySuccess10',
      component: BuySuccess10
    },
    {
      path: '/success11',
      name: 'BuySuccess11',
      component: BuySuccess11
    }
    ,
    {
      path: '/success12',
      name: 'BuySuccess12',
      component: BuySuccess12
    },
    {
      path: '/successtest',
      name: 'BuySuccessTest',
      component: BuySuccessTest
    },
    {
      path: '/cancel',
      name: 'Cancel',
      component: Cancel
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js